import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestSignatoryRejected(props) {
    const { actor, timestamp, message } = props;
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const userName = (actor === null || actor === void 0 ? void 0 : actor.name) || fallbackName;
    return (<ActivityEntry appearance="danger" icon={getIcon('danger')} timestamp={timestamp} message={message} text={<ActivityEntryText>
          <Trans comment="Esigning request - Signatory rejected the sign request">
            <b>{userName}</b> rejected the sign request
          </Trans>
        </ActivityEntryText>}/>);
}
